import type { Entry } from "@/shared/types/entries";
import type { ActionFormSubmit } from "@/v2/components/action-dialog/ActionForm";
import {
	CollapseDialog,
	type CollapseDialogSubmit,
} from "@/v2/components/CollapseDialog";
import { GroupDialog } from "@/v2/components/GroupDialog";
import { MergeDialog } from "@/v2/components/MergeDialog";
import type { EntryFieldConflict } from "../types";

export interface EntryWorkflowDialogsProps {
	groupEntries: Entry[] | null;
	groupConflicts?: EntryFieldConflict[];
	mergeEntries: Entry[] | null;
	mergeConflicts?: EntryFieldConflict[];
	collapseEntries: Entry[] | null;
	defaultIncludeUnits: boolean;
	onGroupOpenChange: (open: boolean) => void;
	onMergeOpenChange: (open: boolean) => void;
	onCollapseOpenChange: (open: boolean) => void;
	onGroupSubmit: (values: ActionFormSubmit) => void;
	onMergeSubmit: (values: ActionFormSubmit) => void;
	onCollapseSubmit: (values: CollapseDialogSubmit) => void;
}

export function EntryWorkflowDialogs({
	groupEntries,
	groupConflicts,
	mergeEntries,
	mergeConflicts,
	collapseEntries,
	defaultIncludeUnits,
	onGroupOpenChange,
	onMergeOpenChange,
	onCollapseOpenChange,
	onGroupSubmit,
	onMergeSubmit,
	onCollapseSubmit,
}: EntryWorkflowDialogsProps) {
	return (
		<>
			<GroupDialog
				entries={groupEntries ?? []}
				open={groupEntries !== null}
				onOpenChange={onGroupOpenChange}
				conflicts={groupConflicts}
				defaultIncludeUnits={defaultIncludeUnits}
				onSubmit={onGroupSubmit}
			/>

			<CollapseDialog
				entries={collapseEntries ?? []}
				open={collapseEntries !== null}
				onOpenChange={onCollapseOpenChange}
				onSubmit={onCollapseSubmit}
			/>

			<MergeDialog
				entries={mergeEntries ?? []}
				open={mergeEntries !== null}
				onOpenChange={onMergeOpenChange}
				conflicts={mergeConflicts}
				onSubmit={onMergeSubmit}
			/>
		</>
	);
}
